export default "__VITE_ASSET__7b$xLR1t__"